
export default {
  name: 'mock-panel',
  props: {
    buttons: {
      type: Array,
      default: function () {
        return [];
      }
    }
  }
};
